import { cn } from '@lib/utils'
import * as RadixTooltip from '@radix-ui/react-tooltip'
import type { ReactNode } from 'react'

type TooltipProps = RadixTooltip.TooltipTriggerProps & {
  children: ReactNode
  description: string
  className?: string
}

export function Tooltip({
  children,
  description,
  className,
  ...props
}: TooltipProps): JSX.Element {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger {...props} asChild>
          {children}
        </RadixTooltip.Trigger>

        <RadixTooltip.Portal>
          <RadixTooltip.Content
            sideOffset={4}
            className={cn(
              'z-[9999] rounded-[4px] bg-white px-2 py-1',
              className,
            )}
          >
            {description}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  )
}
